import { gql, Resolver } from '@apollo/client';
import axios from 'axios';

/**
 * @typedef {CheckInvitationListArgs}
 * @property {string} invitationListUrl URL for the endpoint to check if an email address has been
 * added to the invitation list
 */
interface CheckInvitationListArgs {
    email: string;
    invitationListUrl: string;
}

/**
 * Check if an email address has been added to the invitation list.
 * @param obj
 * @param {CheckInvitationListArgs} args
 * @param context
 */
export const checkInvitationList: Resolver = async (
    obj: Record<string, unknown>,
    args: CheckInvitationListArgs,
): Promise<{ hasInvitation: boolean } | Error> => {
    const { email: emailArg, invitationListUrl } = args;
    const email = emailArg.toLowerCase();

    const result = await axios({
        method: 'post',
        url: invitationListUrl,
        data: {
            email,
        },
    });

    return {
        hasInvitation: result?.data?.whitelisted ?? false,
    };
};

export const CHECK_INVITATION_LIST = gql`
    query CheckInvitationList($email: String!, $invitationListUrl: String!) {
        checkInvitationList(
            email: $email
            invitationListUrl: $invitationListUrl
        ) @client
    }
`;
